module.exports = "//static.hsappstatic.net/documents-ui/static-2.68839/images/no-results.svg"